import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { X, Expand } from "lucide-react";

const IMG = "/images/galerie";

const PHOTOS = [
  { src: `${IMG}/DSC09044_thumb.jpg`, caption: "Lorenzsteinweg in der Abendsonne" },
  { src: `${IMG}/DSC04421_thumb.jpg`, caption: "Erdbeerblüte im Frühjahr" },
];

export default function Galerie() {
  const [active, setActive] = useState(null);

  return (
    <section id="galerie" className="py-16 md:py-28" data-testid="galerie-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="06"
          eyebrow="Fotos"
          title="Echte Einblicke in die Anlage"
          text="Aufgenommen in und um die Parzellen der Gartenanlage Schönwald – von der Erdbeerblüte bis zum Sonnenuntergang über den Gärten."
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PHOTOS.map((p, i) => (
            <Reveal key={p.src} delay={(i % 3) * 0.07}>
              <button
                onClick={() => setActive(p)}
                data-testid={`gallery-item-${i}`}
                className="group relative block w-full overflow-hidden rounded-2xl border border-[#D8D3C5] aspect-[16/9]"
              >
                <img
                  src={p.src}
                  alt={p.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                />
                <span className="absolute inset-0 bg-[#1A382B]/0 transition-colors duration-500 group-hover:bg-[#1A382B]/35" />
                <span className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-left opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="text-xs font-medium text-white">{p.caption}</span>
                  <Expand size={15} className="text-white shrink-0" />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <AnimatePresence>
        {active && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[80] flex items-center justify-center bg-[#1A251E]/90 backdrop-blur-sm p-4"
            onClick={() => setActive(null)}
            data-testid="gallery-lightbox"
          >
            <motion.figure
              initial={{ scale: 0.92, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.95, y: 10 }}
              transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
              className="relative max-w-xl w-full"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={active.src} alt={active.caption} className="w-full rounded-2xl object-contain bg-[#1A251E]" />
              <figcaption className="mt-3 text-center font-display italic text-lg text-[#C4D2C8]">{active.caption}</figcaption>
              <button
                onClick={() => setActive(null)}
                data-testid="gallery-lightbox-close"
                aria-label="Schließen"
                className="absolute -top-3 -right-3 flex h-10 w-10 items-center justify-center rounded-full bg-[#C85A32] text-white transition-transform hover:scale-110"
              >
                <X size={18} />
              </button>
            </motion.figure>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
}
